// import here all required polyfills
import { polyfillObjectFromEntries } from "~~/polyfills";

export default defineNuxtPlugin(() => {
  polyfillObjectFromEntries();
});
